import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';
import { OrderPrice } from '../../services/getOrderPrice';

export function getProgramSinglePaymentPrice(challenge: Challenge) {
  return challenge?.settings?.pricing?.singlePayment?.price;
}

export function getProgramSinglePaymentAmount(challenge: Challenge) {
  return getProgramSinglePaymentPrice(challenge)?.amount;
}

export function isProgramHasOneTimePayment(challenge: Challenge) {
  return Boolean(getProgramSinglePaymentAmount(challenge));
}

/**
 * Gets price from order service or falls back to challenge settings.
 * This is used when the feature toggle is enabled to read price from Order Service.
 *
 * @param orderPrice - Price from Order Service (can be null if fetch failed)
 * @param challenge - Challenge data for fallback
 * @returns Price object with amount and currency
 */
export function getPriceFromOrderOrChallenge(
  orderPrice: OrderPrice | null,
  challenge: Challenge,
): { amount?: string; currency?: string } | undefined {
  if (orderPrice) {
    return {
      amount: orderPrice.amount,
      currency: orderPrice.currency,
    };
  }

  // Fallback to challenge settings
  return getProgramSinglePaymentPrice(challenge);
}
